import {
  abyssColors,
  POI_MARKER_LABEL_BACKGROUND_COLOR,
  POI_MARKER_LABEL_BLACK_TEXT_COLOR,
} from '@/theme/colors';
import { Box, Stack, Typography, styled as muiStyled } from '@mui/material';
import { MarkerLabelConfigTypeEnum } from '@/__generated__/graphql';

export const Arrow = muiStyled(Box)(({ background }: { background: string }) => ({
  height: 0,
  position: 'absolute',
  top: '-0.1rem',
  borderLeft: '0.8rem solid transparent',
  borderRight: '0.8rem solid transparent',
  borderTop: `0.9rem solid ${background}`,
}));

export const Ellipse = muiStyled(Box)(() => ({
  width: '0.6rem',
  height: '0.6rem',
  backgroundColor: abyssColors.error[500],
  borderRadius: '50%',
  aspectRatio: '1/1',
}));

export const Content = muiStyled(Stack)(
  ({
    background,
    variant,
  }: {
    background: string;
    variant?: MarkerLabelConfigTypeEnum | undefined;
  }) => ({
    background: `${background}`,
    padding: '0.8rem',
    borderRadius: '0.4rem',
    width: '100%',
    height: 'fit-content',
    gap: '0.4rem',
    minWidth: variant === MarkerLabelConfigTypeEnum.Detailed ? '19.6rem' : '0',
  })
);

export const Detail = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1.2rem',
}));

export const Title = muiStyled(Typography)(({ color }: { color: string }) => ({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '1rem',
  color: `${
    color === POI_MARKER_LABEL_BACKGROUND_COLOR
      ? abyssColors.neutral[50]
      : POI_MARKER_LABEL_BLACK_TEXT_COLOR
  }`,
  lineHeight: '1.2rem',
  whiteSpace: 'nowrap',
}));

export const DetailLabel = muiStyled(Title)(() => ({
  fontWeight: 500,
}));

export const DetailValue = muiStyled(Typography)(() => ({
  fontFamily: 'Roboto',
  fontWeight: 500,
  fontSize: '1rem',
  color: abyssColors.neutral[50],
  lineHeight: '100%',
  textAlign: 'right',
}));
